import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const ShieldIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      htmlColor='transparent'
      stroke="currentColor"
      strokeWidth="0.75"

    >
      <path
        d="M16.6663 10.8333C16.6663 15 13.7497 17.0833 10.283 18.2916C10.1015 18.3531 9.90429 18.3502 9.72467 18.2833C6.24967 17.0833 3.33301 15 3.33301 10.8333V4.99997C3.33301 4.77895 3.42081 4.56699 3.57709 4.41071C3.73337 4.25443 3.94533 4.16663 4.16634 4.16663C5.83301 4.16663 7.91634 3.16663 9.36634 1.89997C9.54289 1.74913 9.76747 1.66626 9.99967 1.66626C10.2319 1.66626 10.4565 1.74913 10.633 1.89997C12.0913 3.17497 14.1663 4.16663 15.833 4.16663C16.054 4.16663 16.266 4.25443 16.4223 4.41071C16.5785 4.56699 16.6663 4.77895 16.6663 4.99997V10.8333Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}
